import { render } from "./integrationList.vue?vue&type=template&id=77996bf0&scoped=true"
import script from "./integrationList.vue?vue&type=script&lang=js"
export * from "./integrationList.vue?vue&type=script&lang=js"

import "./integrationList.vue?vue&type=style&index=0&id=77996bf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77996bf0"]])

export default __exports__